import { useState } from 'react';

export const useLoadingLogic = () => {
  const [overlay, setOverlayState] = useState<string | null>(
    null
  );
  const isOverlay = Boolean(overlay);

  const setOverlay = (message?: string | null) => {
    setOverlayState(message ? message : null);
  };

  return {
    overlay,
    isOverlay,
    setOverlay,
  };
};
